import { Pressable } from '@react-aria/interactions'
import Styles from './UploadsDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'

interface Props {
  title: string
  onPress: () => void
}

export const SectionHeader = ({ title, onPress }: Props) => {
  return (
    <Pressable onPress={onPress}>
      <div className={Styles.horizontalContainer}>
        <Text variant="smallList" color="var(--dark-80)">
          {title}
        </Text>
        <Button size="xs" variant="ghost" endIcon={ArrowRight} onPress={onPress}>
          See All
        </Button>
      </div>
    </Pressable>
  )
}
